import {
  Box,
  Stack,
  ToggleButtonGroup,
  Typography,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DashboardToggleTimeButton } from './DashboardToggletimeButton';
import { DayPickerValues } from './dayPickerValues';
import { useCallback } from 'react';
import { IconInfoCircle } from '@tabler/icons-react';
import { ESPopover } from '@energy-stacks/core/ui';

type DashboardTimePickerToggleButtonGroupProps = {
  value: DayPickerValues | null;
  onChange: (value: DayPickerValues) => void;
  infoText?: string;
};

export const DashboardTimePickerToggleButtonGroup: React.FC<
  DashboardTimePickerToggleButtonGroupProps
> = ({ value, onChange, infoText }) => {
  const { t } = useTranslation('dashboard');
  const theme = useTheme();

  const handleChange = useCallback(
    (
      _event: React.MouseEvent<HTMLElement, MouseEvent>,
      value: DayPickerValues
    ) => {
      if (value === null) {
        return;
      }
      onChange(value);
    },
    [onChange]
  );

  return (
    <Box display="flex" alignItems="center" gap={7.25}>
      <Stack alignItems="center" direction="row" gap={3}>
        <Typography sx={{ color: theme.palette.grey[900] }}>
          {t('time_period')}
        </Typography>
        {infoText ? (
          <ESPopover content={<Typography>{infoText}</Typography>} breakWord>
            <IconInfoCircle
              size={24}
              style={{ cursor: 'pointer' }}
              color={theme.palette.primary.main}
            />
          </ESPopover>
        ) : null}
      </Stack>

      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={handleChange}
        sx={{
          backgroundColor: theme.palette.grey[100],
          borderRadius: theme.spacing(2),
        }}
      >
        <DashboardToggleTimeButton text={t('day')} value="1" />
        <DashboardToggleTimeButton text={t('week')} value="7" />
        <DashboardToggleTimeButton text={t('month')} value="30" />
        <DashboardToggleTimeButton text={t('year')} value="365" />
      </ToggleButtonGroup>
    </Box>
  );
};
